import * as ActionType from '../actions/types'
import { getCookieClient } from 'settings/app/helpers'

/**
 * check if localisation cookie exist
 * add client-name if cookie exists to 'insuredBenefits'
 * @param data
 */
const setFilteredBenefitsList = (data) => {
  const clientValue = getCookieClient()

  data.insuredBenefits = {
    clientName: clientValue.clientName,
    items: data.insuredBenefits,
  }
}

const detailsReducer = (state = null, action) => {
  switch (action.type) {
    case ActionType.FETCH_DETAILS_COMPLETE:
      // copy original data
      const reducedData = action.payload ? { ...action.payload } : null

      // create filtered data for insuredBenefits (if exist)
      if (reducedData && reducedData.result.details.insuredBenefits) {
        setFilteredBenefitsList(reducedData.result.details)
      }

      return reducedData

    default:
      return state
  }
}

export default detailsReducer
